import type { SwingTilesRowScopeLike } from './tilesRowPanelData'

/**
 * Имя регистрации action/элемента внутри строки Tiles:
 * `{tableFieldName}__row{rowIndex}__{baseName}`.
 * Вне Tiles возвращает baseName без изменений.
 */
export function resolveTilesRowScopedRegistryName(
  scope: SwingTilesRowScopeLike | null | undefined,
  baseName: string | null | undefined,
): string {
  const name = String(baseName ?? '').trim()
  if (!scope) return name

  const tableFieldName = String(scope.tableFieldName ?? '').trim()
  const rowIndex = Number(scope.rowIndex)
  if (!tableFieldName || !Number.isFinite(rowIndex) || rowIndex < 0) {
    return name
  }

  return name ? `${tableFieldName}__row${rowIndex}__${name}` : name
}
